<template>
    <div :class="['notification', {'notification--error': type === 'error', 'notification--success': type === 'success'}]">
      <img class="notification__icon" alt="notification icon" :src="type === 'error' ? errorIconSrc : successIconSrc">
      <span v-if="description" class="notification__description">{{ description }}</span>
      <div v-if="$slots.default" class="notification__additional">
        <slot></slot>
      </div>
    </div>
  </template>

<script>
export default {
  props: {
    description: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      validator: value => ['error', 'success'].includes(value),
      default: 'success',
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require, import/no-unresolved
      errorIconSrc: require('@/assets/images/icons/i_error.svg'),
      // eslint-disable-next-line global-require, import/no-unresolved
      successIconSrc: require('@/assets/images/icons/checkmark-filled.svg'),
    };
  },
};
</script>

  <style scoped>
  .notification {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
    border-radius: 4px;
    overflow: hidden;
    padding: 1rem;
  }

  .notification--error {
    border-left: 4px solid #AB2017;
    background-color: #FFEDED;
  }

  .notification--success {
    border-left: 4px solid #1F9F43;
    background-color: #E6F1EC;
  }

  .notification__icon {
  }

  .notification__description {
  }
  </style>
